import React from "react";
import { PieChart, Pie, Tooltip, ResponsiveContainer, Cell, Label } from "recharts";
import * as PropTypes from "prop-types";

 export const CustomPieChart = ({
    data,
    totalValue = '',
}) => {
    return (
        <ResponsiveContainer width="100%" height="100%">
            <PieChart
            >
                <Pie
                    dataKey="value"
                    data={data}
                    innerRadius="85%"
                    outerRadius="100%"
                    cornerRadius={20}
                    paddingAngle={-10}
                    stroke="none"
                    fill="#82ca9d"
                >
                    {!!totalValue && (
                        <Label value={totalValue} fontSize="1.8rem" fontWeight="bold" fill="#20295C" position="center" />
                    )}
                    {data.map((entry, index) => (
                        <Cell key={`cell-${entry.color}`} fill={entry.color} />
                    ))}
                </Pie>
                <Tooltip formatter={(value) => `${value}%`} />
            </PieChart>
        </ResponsiveContainer>
    );
};

CustomPieChart.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
    })),
    totalValue: PropTypes.string
};

export default CustomPieChart;
